import React, { useState, useEffect } from 'react';
import { LucidLoader } from '../icons';

const MetaDataThreeDComponent = ({ item, masterThreeDTechnologyData }) => {
    const [resolvedMeta, setResolvedMeta] = useState({
        technology: '',
        material: '',
        postProcess: '',
    });

    useEffect(() => {
        if (!item || !masterThreeDTechnologyData?.length) return;

        const tech = masterThreeDTechnologyData.find(
            (techItem) => techItem?._id === item?.threeDTechnology
        );

        const machine = tech?.machines?.find(
            (machineItem) => machineItem?._id === item?.threeDMachine
        );

        const material = machine?.materials?.find(
            (materialItem) => materialItem?._id === item?.threeDMaterial
        );

        const postProcess = material?.postProcess?.find(
            (ppItem) => ppItem?._id === item?.threeDPostProcessing
        );

        setResolvedMeta({
            technology: tech?.name || '',
            material: material?.name || '',
            postProcess: postProcess?.name || '',
        });
    }, [item, masterThreeDTechnologyData]);

    const renderRow = (label, value) => (
        value ? (
            <div className="flex space-y-0 text-sm text-gray-800">
                <span className="min-w-[90px]">{label}:</span>
                <span className="truncate">{value}</span>
            </div>
        ) : null
    );

    const isLoading = !resolvedMeta.technology;

    return (
        <div className="w-full max-w-md px-2 py-1">
            {isLoading ? (
                <div className="flex items-center justify-center h-24 text-primaryColor">
                    <LucidLoader />
                </div>
            ) : (
                <div className="flex flex-col -space-y-1">
                    {renderRow('Technology', resolvedMeta.technology)}
                    {renderRow('Material', resolvedMeta.material)}
                    {renderRow('Post Process', resolvedMeta.postProcess)}
                </div>
            )}
        </div>
    );
};

export default MetaDataThreeDComponent;
